<template>
    <toolbar-option>
        <template slot="primary">
            <dropdown
                :value="selectedPreset"
                :options="presetOptions"
                native
                @input="onInput"
            />
        </template>
    </toolbar-option>
</template>

<script>
import { mapState } from 'vuex';

import baseOption from '@/options/mixins/base-option';
import listenOnRootMixin from '@/mixins/listen-on-root';

export default {
    name: 'add-preset',
    mixins: [baseOption, listenOnRootMixin],

    data() {
        return {
            displayName: 'Preset',
            elementPresets: [],
            selectedPreset: '',
        };
    },

    computed: {
        ...mapState({
            presets: state => state.page.presets,
            selectedRendering: state => state.page.selectedRendering,
        }),

        element() {
            return this.selectedElements[0];
        },

        hasPresets() {
            return this.presets && Object.prototype.hasOwnProperty.call(this.presets, this.element.elementType);
        },

        isComponentEditor() {
            return this.$route.name === 'components';
        },

        presetsEnabled() {
            return (
                this.selectedRendering
                && !this.selectedRendering.lockComponentNew
                && !this.isGlobalContent
                && this.hasPresets
            ) || (
                this.isComponentEditor
                && this.hasPresets
            );
        },

        isGlobalContent() {
            if (!this.selectedRendering) return false;

            return this.selectedRendering.globalContent;
        },

        presetOptions() {
            return [
                { text: 'None', value: '' },

                ...this.elementPresets.map(preset => ({
                    text: preset.name,
                    value: preset.id,
                })),
            ];
        },
    },

    created() {
        this.listenOnRoot('flex::preset::remove', this.clearPreset);
    },

    methods: {
        clearPreset() {
            this.selectedPreset = '';
        },

        async onInput(presetId) {
            this.selectedElements.forEach((selectedElement) => {
                if (!presetId) {
                    selectedElement.clearClasses();
                    selectedElement.presetId = '';
                    selectedElement.removeElementData('presetId', presetId);
                } else {
                    selectedElement.presetId = presetId;
                    selectedElement.setElementData('presetId', presetId);
                }
            });

            await this.$nextTick();
            this.$root.$emit('flex::preset::update');
        },

        onSelectedElement() {
            const presets = this.presets[this.element.elementType]
                ? this.presets[this.element.elementType].elementPresets
                : [];

            this.elementPresets = presets.sort((a, b) => (a.name < b.name ? -1 : 1));
            this.selectedPreset = this.element.getElementData('presetId') || '';
        },
    },
};
</script>
